import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DivisionService from "../../services/Division/DivisionService";
import styles from './UniversityHome.module.css';
import noresfoundIcon from '../../assets/noresfoundIcon.png';

const DivisionHome = () => {
  const [divisions, setDivisions] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
 
  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const response = await DivisionService.GetDivisionByUniversityId();
        if (response.data.status && response.data.object?.divisions) {
          setDivisions(response.data.object.divisions);
        }
      } catch (error) {
        console.error('Error fetching divisions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDivisions();
  }, []);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loader}></div>
      </div>
    );
  }

  if (!divisions.length) {
    return (
      <div className={styles.notFoundContainer}>
        <img src={noresfoundIcon} alt="No results found" className={styles.notFoundImage} />
        <h2>No Divisions Found</h2>
        <p>We couldn't find any divisions for this selection. Please try a different category or check back later.</p>
      </div>
    );
  }

  const handleDivisionClick = (divisionPublicUri) => {
    if (divisionPublicUri && divisionPublicUri.trim() !== '') {
      // Check if current path already contains 'Division'
      const currentPath = location.pathname;
      const pathParts = currentPath.split('/').filter(part => part);
      
      // If current path already starts with 'Division', navigate without adding another 'Division'
      if (pathParts[0] === 'Division') {
        navigate(`/Division/${divisionPublicUri}`);
      } else {
        navigate(`Division/${divisionPublicUri}`);
      }
    }
  };

  return (
    <div className="container-custom py-4">
      <h1 className={styles.title}>Academic Divisions</h1>
      <div className={styles.divisionsList}>
        {divisions.map((division, index) => (
          <div 
          tabIndex={0}  
          role="button"  
          aria-label={`Go to ${division.divisionName}`}  
            key={index} 
            className={`${styles.divisionItem} ${
              division.divisionPublicUri && division.divisionPublicUri.trim() !== '' 
                ? styles.clickable 
                : ''
            }`}
            onClick={() => handleDivisionClick(division.divisionPublicUri)}
              onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleDivisionClick(division.divisionPublicUri);
                            }
                        }}
          >
            {division.divisionName}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DivisionHome;
